import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../../../shared/services/storage.service';
import { ReviewerService } from '../../../../shared/services/reviewer.service';
import { Reviewer } from '../../../../store/reviewer/reviewer.interface';
import { EmittersService } from '../../../../shared/services/emitters.service';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { CommonBaseClass } from '../../../../shared/classes/common-base-class';
import { HelperService } from '../../../../shared/services/helper.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-education',
  standalone: true,
  imports: [CommonModule, PipesModule, TooltipModule],
  templateUrl: './edit-profile-main.component.html',
  styleUrl: './edit-profile-main.component.scss'
})
export class EditProfileMainComponent extends CommonBaseClass implements OnInit {

  credentials = [];
  skillsAndExperience = [];
  reviewer!: Reviewer;
  tenant: any = {};
  constructor(private router:Router, 
    private storageService: StorageService, 
    private reviewerService: ReviewerService, 
    private eventEmitterService: EmittersService,
    helperService: HelperService
  ){
    super(helperService)
  }

  async ngOnInit(): Promise<void> {
    await this.reviewerService.fetchReviewerAndUpdateTenants();
    this.reviewer = this.reviewerService.getReviewer();
    this.getCredentials();
    this.getSkillAndExperience();
    this.subscribeEvents();
    this.getProfileStrength();
  }

  subscribeEvents(){
    this.eventEmitterService.tenantEmitter.subscribe(async () => {
      this.getCredentials();
      this.getSkillAndExperience();
    });
  }

  getCredentials(): void{
    this.reviewerService.getFilteredCredentialBasedUserSkills(this.reviewer._id).subscribe((credentials) => {
      this.credentials = credentials;
    })
  }

  getSkillAndExperience(): void{
    this.reviewerService.getFilteredCriteriaBasedUserSkills(this.reviewer._id).subscribe((skillsAndExperience) => {
      this.skillsAndExperience = skillsAndExperience;
    })
  }

  getProfileStrength(){
    this.tenant = this.storageService.getTenant();
  }

  goto(url:string){
    this.router.navigateByUrl(url);
  }

  getGradientClass(){
    if(this.isPWCEnabled){
      return 'simple-ui';
    }
    if(this.isMobile){
      return 'gradient-ul';
    }
    return 'simple-ui';
  }
}
